import React from 'react';
import ClassAssembly9E  from 'views/ClassAssembly9E';

const ClassAssembly9EPage = () => {
    return <ClassAssembly9E />;
  };
  
  export default ClassAssembly9EPage;

  //9E